export const INITIAL_LOAD_FIELD_KEY: string = ''
export const INITIAL_LOAD_FIELD_VALUE: number | null = null

export const INITIAL_LOAD_FIELD: Record<string, number | null> = {
  [INITIAL_LOAD_FIELD_KEY]: INITIAL_LOAD_FIELD_VALUE,
}
